import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=477c64fa&scoped=true&"
import script from "./CustomInput.vue?vue&type=script&lang=ts&"
export * from "./CustomInput.vue?vue&type=script&lang=ts&"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=477c64fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c64fa",
  null
  
)

export default component.exports